import {
  GET_ARTICLES,
  GET_RECENT_ARTICLE,
  CREATE_ARTICLE,
  ARTICLE_ERROR,
  UPDATE_ARTICLE_LIKES,
  DELETE_ARTICLE,
  ADD_ARTICLE_COMMENT,
  ADD_ARTICLE_REPLY,
  GET_ARTICLE,
  REMOVE_ARTICLE_COMMENT,
  GET_ARTICLE_COMMENTS,
  CLEAR_ARTICLE,
} from "../actions/types";

const initialState = {
  articles: [],
  article: {},
  recentarticle: {},
  articleloading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ARTICLES:
      return {
        ...state,
        articles: payload,
        articleloading: false,
      };
    case GET_ARTICLE:
      return {
        ...state,
        article: payload,
        articleloading: false,
      };
    case GET_RECENT_ARTICLE:
      return {
        ...state,
        recentarticle: payload,
        articleloading: false,
      };
    case CREATE_ARTICLE:
      return {
        ...state,
        article: payload,
        articleloading: false,
      };
    case DELETE_ARTICLE:
      return {
        ...state,
        articles: payload,
        articleloading: false,
      };
    case ARTICLE_ERROR:
      return {
        ...state,
        error: payload,
        articleloading: false,
      };
    case UPDATE_ARTICLE_LIKES:
      return {
        ...state,
        articles: state.articles.map((article) =>
          article._id === payload.id
            ? { ...article, likes: payload.likes }
            : article
        ),
        articleloading: false,
      };
    case ADD_ARTICLE_COMMENT:
      return {
        ...state,
        article: { ...state.article, comments: payload },
        articleloading: false,
      };
    case REMOVE_ARTICLE_COMMENT:
      return {
        ...state,
        article: {
          ...state.article,
          comments: state.article.comments.filter(
            (comment) => comment._id !== payload
          ),
        },
        articleloading: false,
      };
    case ADD_ARTICLE_REPLY:
      return {
        ...state,
        article: { ...state.article, replies: payload },
        articleloading: false,
      };
    case GET_ARTICLE_COMMENTS:
      return {
        ...state,
        articles: payload,
        articleloading: false,
      };
    case CLEAR_ARTICLE:
      return {
        ...state,
        article: {},
        recentarticle: {},
        articles: [],
        articleloading: false,
      };
    default:
      return state;
  }
}
